import React from 'react';

const SignUp1 = React.lazy(() => import('./pages/Authentication/SignUp/SignUp1'));
const Signin1 = React.lazy(() => import('./pages/Authentication/SignIn/SignIn1_old'));
const cadPainel = React.lazy(() => import('./pages/Painel/index'));
const acompanhamentoAtedimento = React.lazy(() => import('./pages/Paciente/AcompanhamentoAtendimento'));
const telemedicina = React.lazy(() => import('./pages/TeleMedicina/Index'));
const telemedicinaOpcoes = React.lazy(() => import('./pages/TeleMedicina/OptionsPage'));
const telemedicinaWait = React.lazy(() => import('./pages/TeleMedicina/WaitingRoomPage'));
const cozinha = React.lazy(() => import('./pages/Atendimento/Cozinha.js'));

const route = [
    { path: '/auth/login/', exact: false, name: 'Login e-saude', component: Signin1 },
    { path: '/painel/:id?', exact: false, name: 'Painel ', component: cadPainel },
    { path: '/acompanhamento-atendimento/:boletim_id?', exact: false, name: 'Painel ', component: acompanhamentoAtedimento },    
    { path: '/telemedicina/options/:cpf', exact: true, name: 'eSaude - Tele Medicina', component: telemedicinaOpcoes },
    { path: '/telemedicina/wait/:cpf', exact: true, name: 'eSaude - Tele Medicina', component: telemedicinaWait },
    { path: '/telemedicina/', exact: false, name: 'eSaude - Tele Medicina', component: telemedicina },
    { path: '/cozinha', exact: true, name: 'Cozinha', component: cozinha }
    
];

export default route;